/**
 * Model for our staged field.
 * 
 * @package Ninja Forms builder
 * @subpackage Fields
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'models/fields/stagingModel',[], function() {
	var model = Backbone.Model.extend( {
	} );
	
	return model;
} );
